module.exports = __webpack_public_path__ + "img/three-2.10a23b9e.jpg";